export default "__VITE_ASSET__47341d2f__"